﻿

/*------------------------------------*\
    #INTERNAL-MESSAGE-SETTINGS
\*------------------------------------*/


window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.internalMessageSettings = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {

        $(document).on("click", ".js-message-settings-tab", function (e) {
            e.preventDefault();
            var control = this;
            var target = $(control).data("tab");

            if (!$(control).hasClass("is-active")) {
                $(control)
                    .addClass("is-active")
                    .siblings(".message-settings-tab")
                    .removeClass("is-active");

                $(control)
                    .closest(".message-settings-tab-container")
                    .next(".message-settings-content-container")
                    .find(".message-settings-content")
                    .removeClass("is-active")
                    .filter("[data-tab='" + target + "']")
                    .addClass("is-active");
            }
        });

        $(document).on("click", ".js-open-message-settings", function (e) {
            e.preventDefault();
            var control = this;

            if (!$(control).closest(".setting-link").hasClass("is-active")) {
                $(control)
                    .closest(".setting-link")
                    .addClass("is-active");

                $(control)
                    .closest(".js-user-company-row")
                    .find(".js-user-card-message-settings")
                    .slideDown("150", function () {
                        $(this)
                            .addClass("is-expanded")
                            .removeAttr("style");
                    });
            } else {
                $(control)
                    .closest(".js-user-company-row")
                    .find(".js-user-card-message-settings")
                    .slideUp("150", function () {
                        $(control)
                            .closest(".setting-link")
                            .removeClass("is-active");

                        $(this)
                            .removeClass("is-expanded")
                            .removeAttr("style");
                    });
            }
        });

        $(document).on("click", ".js-close-message-settings", function (e) {
            e.preventDefault();
            var control = this;

            $(control)
                .closest(".js-user-company-row")
                .find(".js-open-message-settings")
                .trigger("click");
        });
    };

    // Initialize module
    $(function () {
        priv.init();
    });

})();
